const BASE_URL =
    process.env.REACT_APP_API_URL;

/* =========================================
   COMMON API HANDLER
========================================= */

const getHeaders = () => {

    const token =
        localStorage.getItem("authToken");

    if (!token) {
        throw new Error(
            "NO_AUTH_TOKEN"
        );
    }

    return {
        Accept: "application/json",
        "Content-Type":
            "application/json",
        Authorization: `Bearer ${token}`,
    };
};

const handleResponse = async (
    response
) => {

    if (!response.ok) {

        if (
            response.status === 401 ||
            response.status === 403
        ) {

            throw new Error(
                "SESSION_EXPIRED"
            );
        }

        if (response.status === 404) {

            throw new Error(
                "DATA_NOT_FOUND"
            );
        }

        throw new Error(
            "API_ERROR"
        );
    }

    return await response.json();
};

/* =========================================
   ADMIN STATISTICS API
========================================= */
/* =========================================
   PAST 7 DAYS TREND API
========================================= */

export const getPast7DaysTrend =
    async () => {

        try {

            const response =
                await fetch(
                    `${BASE_URL}/food/api/orders/admin/statistics`,
                    {
                        method: "GET",

                        headers:
                            getHeaders(),

                        credentials:
                            "include",
                    }
                );

            const result =
                await handleResponse(
                    response
                );

            return result;

        } catch (error) {

            console.error(
                "Trend API Error:",
                error
            );

            throw error;
        }
    };




// Add this function to your existing AdminService.js

/* =========================================
   GET ADMIN STATISTICS WITH DATE FILTER
========================================= */

export const getAdminStatistics = async (vendorId, fromDate, toDate) => {
    try {
        let url = `${BASE_URL}/food/api/orders/admin/statistics`;
        const params = new URLSearchParams();

        if (vendorId) {
            params.append('vendorId', vendorId);
        }

        if (fromDate) {
            params.append('fromDate', fromDate);
        }

        if (toDate) {
            params.append('toDate', toDate);
        }

        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        const response = await fetch(url, {
            method: "GET",
            headers: getHeaders(),
            credentials: "include",
        });

        const result = await handleResponse(response);

        // If no data found
        if (result.message === "No orders found for selected date range") {
            return result;
        }

        // Transform the response to match the expected format
        return {
            totalRevenue: result.totalRevenue || 0,
            revenueGrowthPercent: result.salesGrowth || "0%",
            avgOrderValue: result.totalOrders > 0
                ? (result.totalRevenue / result.totalOrders).toFixed(2)
                : 0,
            totalOrders: result.totalOrders || 0,
            paymentBreakdown: (result.paymentMethods || []).reduce((acc, item) => {
                acc[item.method] = item.count;
                return acc;
            }, {}),
            dailyStats: (result.allVendors || []).map((vendor, index) => ({
                date: new Date(Date.now() - ((result.allVendors.length - index) * 86400000)),
                revenue: vendor.todayRevenue || 0,
            })),
            platformCommission: 0,
            refundAmount: result.todayRefundedOrders || 0,
            todayRevenue: result.todayRevenue,
            totalCustomers: result.totalCustomers,
            todayCustomers: result.todayCustomers,
            todayCancelledOrders: result.todayCancelledOrders,
            totalCancelledOrders: result.totalCancelledOrders,
            todayTotalOrders: result.todayTotalOrders,
            allVendors: result.allVendors,
            topPerformingVendors: result.topPerformingVendors,
            ratingDistribution: result.ratingDistribution,
            averageRating: result.averageRating,
            categoryRatings: result.categoryRatings,
            totalRatings: result.totalRatings,
            paymentMethods: result.paymentMethods,
            todaySuccessRate: result.todaySuccessRate,
            salesGrowth: result.salesGrowth,
            vendorSalesGrowth: result.vendorSalesGrowth,
            newCustomers: result.newCustomers,
            returningCustomers: result.returningCustomers,
            totalRefundedOrders: result.totalRefundedOrders,
        };

    } catch (error) {
        console.error("Admin Statistics Error:", error);
        throw error;
    }
};